import React from 'react';
import PropTypes from 'prop-types';
import contentTypeName from '../../../utils/contentTypeName';
import ModalContainer from './ModalContainer';
import ConfirmModal from './ConfirmModal';

const DeleteContentModal = ({ modalIsOpen, loading, onConfirmClick, onCloseClick, contentType }) => (
  <ModalContainer
    isOpen={modalIsOpen}
    closeModal={onCloseClick}
    label="Delete Content modal"
  >
    <ConfirmModal
      loading={loading}
      title="Are you sure?"
      confirmText={`Delete ${contentTypeName(contentType)}`}
      onConfirmClick={onConfirmClick}
      onCloseClick={onCloseClick}
    >
      <p>{`Are you sure you want to delete this ${contentTypeName(contentType)}? This cannot be undone.`}</p>
    </ConfirmModal>
  </ModalContainer>
);

DeleteContentModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  contentType: PropTypes.string.isRequired,
};

export default DeleteContentModal;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/DeleteContentModal.js